<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>user</md-icon>
                    </div>
                    <h4 class="title">Edit Vendor</h4>
                </md-card-header>

                <form @submit.prevent="update">
                        <md-card-content>
                            <div class="text-right">
                                <md-button @click="goBack" class="md-primary md-dense">
                                    Back to List
                                </md-button>
                            </div>

                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Name
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.name"/>
                                        <validation-error :errors="apiValidationErrors.name"/>
                                    </md-field>
                                </div>
                            </div>

                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Short Name
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.short_name"/>
                                        <validation-error :errors="apiValidationErrors.short_name"/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout spacing">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Description
                                </label>
                                <div class="md-layout-item">
                                    <ckeditor
                                            :editor="editor"
                                            v-model="vendor.description"
                                            :config="editorConfig"
                                    ></ckeditor>
                                    <validation-error :errors="apiValidationErrors.description" />
                                </div>
                            </div>
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Address
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.address"/>
                                        <validation-error :errors="apiValidationErrors.address"/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Phone Number
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.phone_number"/>
                                        <validation-error :errors="apiValidationErrors.phone_number"/>
                                    </md-field>
                                </div>
                            </div>

                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Telephone Number
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.telephone_number"/>
                                        <validation-error :errors="apiValidationErrors.telephone_number"/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Email
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.email"/>
                                        <validation-error :errors="apiValidationErrors.email"/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Logo
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.logo"/>
                                        <validation-error :errors="apiValidationErrors.logo"/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-form-label">
                                    Business Name
                                </label>
                                <div class="md-layout-item">
                                    <md-field class="md-invalid">
                                        <md-input v-model="vendor.business_name"/>
                                        <validation-error :errors="apiValidationErrors.business_name"/>
                                    </md-field>
                                </div>
                            </div>
                        </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update vendor</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

export default {
    components: { ValidationError, ckeditor: CKEditor.component },

    mixins: [formMixin],

    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'Outdent',
                'Indent',
                'TextColor',
                'BGColor',
            ],
        },
        vendor: {
            type: 'vendors',
            name: null,
            short_name: null,
            description: null,
            address: null,
            phone_number: null,
            telephone_number: null,
            email: null,
            website:null,
            logo: null,
            business_name:null,
        },
        available_categories: [],

    }),

    created () {
        this.get();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('vendors/get', id);
                this.vendor = this.$store.getters['vendors/vendor'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('vendors/update', this.vendor);
                await this.$store.dispatch(
                    'alerts/success',
                    'Vendor updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },


        goBack () {
            this.$router.push({ name: 'Vendors List' });
        },
    },
};
</script>
<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-inline-checkboxes {
        display: inline-flex;

    .md-checkbox {
        margin-top: 15px !important;
    }
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
</style>
<style >
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>
